import { useState, useEffect } from "react";
import { useTranslation } from "react-i18next";

// Shows a floating action button near footer visibility to jump back to page top.
export default function ScrollToTop() {
  const { t } = useTranslation();
  const [isVisible, setIsVisible] = useState(false);

  useEffect(() => {
    // Set up Intersection Observer to detect footer visibility
    const footer = document.getElementById("contact");

    if (!footer) return;

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          // Show button when footer is intersecting with viewport
          setIsVisible(entry.isIntersecting);
        });
      },
      {
        // Trigger when at least 10% of footer is visible
        threshold: 0.1,
        // Start detecting 100px before footer enters viewport
        rootMargin: "100px",
      }
    );

    observer.observe(footer);

    return () => {
      observer.disconnect();
    };
  }, []);

  // Smoothly scrolls the viewport to the top of the page.
  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  };

  return (
    <button
      onClick={scrollToTop}
      className={`
        fixed bottom-8 right-8 z-50
        max-md:bottom-24 max-md:right-6
        w-14 h-14
        max-md:w-12 max-md:h-12
        flex items-center justify-center
        transform transition-all duration-300 ease-out
        hover:scale-110 hover:-translate-y-1
        focus:outline-none focus-visible:ring-4 focus-visible:ring-caramel-400/50 rounded-full
        ${
          isVisible
            ? "opacity-100 translate-y-0"
            : "opacity-0 translate-y-4 pointer-events-none"
        }
        touch-target
        group
      `}
      aria-label={t("common.scrollToTop", "Scroll to top")}
      style={{
        transition: "opacity 0.3s ease-out, transform 0.3s ease-out",
      }}
    >
      <img
        src="/icons/scroll-to-top-leaf.webp"
        alt=""
        className="w-11 h-11 max-md:w-9 max-md:h-9 drop-shadow-lg transform group-hover:rotate-[-10deg] transition-transform duration-300"
      />
    </button>
  );
}
